import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from '../establishment/url_helper';

import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_ESTABLISHMENT_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Establishments
export const getEstablishmentList = params => {
	return apiClient.get(`${url.GET_ESTABLISHMENTS}?${stringifyParams(params)}`);
};
export const getEstablishmenQuery = params => {
	return apiClient.get(
		`${url.GET_ESTABLISHMENTS_QUERY}?${stringifyParams(params)}`
	);
};
export const getEstablishment = establishment =>
	apiClient.get(url.ESTABLISHMENT + '/' + encodeURIComponent(establishment));
export const addNewEstablishment = establishment =>
	apiClient.post(url.ADD_ESTABLISHMENT, establishment);
export const updateEstablishment = establishment =>
	apiClient.put(
		url.UPDATE_ESTABLISHMENT + '/' + establishment._id,
		establishment
	);
export const deleteEstablishment = establishment =>
	apiClient.delete(url.DELETE_ESTABLISHMENT + '/' + establishment._id);
export const getProductiveCycleActive = establishment =>
	apiClient.get(
		url.GET_ESTABLISHMENT_PRODUCTIVE_CYCLE_ACTIVE +
			'/' +
			encodeURIComponent(establishment)
	);

export const getEstablishmentListForMap = () => {
    return apiClient.get(`${url.GET_ESTABLISHMENTS_QUERY_URL_FOR_MAP}`);
};

// Communes
export const getCommuneList = params => {
	return apiClient.get(`${url.GET_COMMUNES}?${stringifyParams(params)}`);
};
export const getCommune = commune =>
	apiClient.get(url.COMMUNE + '/' + encodeURIComponent(commune));
export const addNewCommune = commune =>
	apiClient.post(url.ADD_COMMUNE, commune);
export const updateCommune = commune =>
	apiClient.put(url.UPDATE_COMMUNE + '/' + commune._id, commune);
export const deleteCommune = commune =>
	apiClient.delete(url.DELETE_COMMUNE + '/' + commune._id);

// Regions
export const getRegionList = () => apiClient.get(url.GET_REGIONS);
export const getRegion = region =>
	apiClient.get(url.REGION + '/' + encodeURIComponent(region));
export const addNewRegion = region => apiClient.post(url.ADD_REGION, region);
export const updateRegion = region =>
	apiClient.put(url.UPDATE_REGION + '/' + region._id, region);
export const deleteRegion = region =>
	apiClient.delete(url.DELETE_REGION + '/' + region._id);

// Sanitary Vicinitys
export const getSanitaryVicinityList = () =>
	apiClient.get(url.GET_SANITARY_VICINITIES);
export const getSanitaryVicinity = sanitaryVicinity =>
	apiClient.get(
		url.SANITARY_VICINITY + '/' + encodeURIComponent(sanitaryVicinity)
	);
export const addNewSanitaryVicinity = sanitaryVicinity =>
	apiClient.post(url.ADD_SANITARY_VICINITY, sanitaryVicinity);
export const updateSanitaryVicinity = sanitaryVicinity =>
	apiClient.put(
		url.UPDATE_SANITARY_VICINITY + '/' + sanitaryVicinity._id,
		sanitaryVicinity
	);
export const deleteSanitaryVicinity = sanitaryVicinity =>
	apiClient.delete(url.DELETE_SANITARY_VICINITY + '/' + sanitaryVicinity._id);

// Productive Areas
export const getProductiveAreaList = () =>
	apiClient.get(url.GET_PRODUCTIVE_AREAS);
export const getProductiveArea = productiveArea =>
	apiClient.get(
		url.PRODUCTIVE_AREA + '/' + encodeURIComponent(productiveArea)
	);
export const addNewProductiveArea = productiveArea =>
	apiClient.post(url.ADD_PRODUCTIVE_AREA, productiveArea);
export const updateProductiveArea = productiveArea =>
	apiClient.put(
		url.UPDATE_PRODUCTIVE_AREA + '/' + productiveArea._id,
		productiveArea
	);
export const deleteProductiveArea = productiveArea =>
	apiClient.delete(url.DELETE_PRODUCTIVE_AREA + '/' + productiveArea._id);

// Establishment Types
export const getEstablishmentTypeList = () =>
	apiClient.get(url.GET_ESTABLISHMENT_TYPES);
export const getEstablishmentType = establishmentType =>
	apiClient.get(
		url.ESTABLISHMENT_TYPE + '/' + encodeURIComponent(establishmentType)
	);
export const addNewEstablishmentType = establishmentType =>
	apiClient.post(url.ADD_ESTABLISHMENT_TYPE, establishmentType);
export const updateEstablishmentType = establishmentType =>
	apiClient.put(
		url.UPDATE_ESTABLISHMENT_TYPE + '/' + establishmentType._id,
		establishmentType
	);
export const deleteEstablishmentType = establishmentType =>
	apiClient.delete(
		url.DELETE_ESTABLISHMENT_TYPE + '/' + establishmentType._id
	);
export const getEstablishmentTypeCodes = codes =>
	apiClient.post(url.ESTABLISHMENT_TYPE_CODES, codes);

// Companies
export const getCompanyList = () => apiClient.get(url.GET_COMPANIES);
export const getCompany = company =>
	apiClient.get(url.COMPANY + '/' + encodeURIComponent(company));
export const addNewCompany = company =>
	apiClient.post(url.ADD_COMPANY, company);
export const updateCompany = company =>
	apiClient.put(url.UPDATE_COMPANY + '/' + company._id, company);
export const deleteCompany = company =>
	apiClient.delete(url.DELETE_COMPANY + '/' + company._id);
export const getCompanyWithHourMeterList = () =>
	apiClient.get(url.GET_COMPANY_WITH_HOUR_METER_LIST);

// Cost Center
export const getCostCenterList = params => {
	return apiClient.get(`${url.GET_COST_CENTER}?${stringifyParams(params)}`);
};
export const getCostCenterQuery = params => {
	return apiClient.get(
		`${url.GET_COST_CENTER_QUERY}?${stringifyParams(params)}`
	);
};
export const getCostCenter = cost_center =>
	apiClient.get(url.COST_CENTER + '/' + encodeURIComponent(cost_center));
export const addNewCostCenter = cost_center =>
	apiClient.post(url.ADD_COST_CENTER, cost_center);
export const updateCostCenter = cost_center =>
	apiClient.put(url.UPDATE_COST_CENTER + '/' + cost_center._id, cost_center);
export const deleteCostCenter = cost_center =>
	apiClient.delete(url.DELETE_COST_CENTER + '/' + cost_center._id);
export const importCostCenter = async data => {
	try {
		const response = await apiClient.post(url.IMPORT_COST_CENTER, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response;
	} catch (error) {
		console.error(
			'[Error] Failed import cost center sheet from excel spreadsheet attached:',
			error.response?.data || error
		);
		throw error;
	}
};

// Holdings
export const getHoldingList = () => apiClient.get(url.GET_HOLDINGS);
export const getHolding = holding =>
	apiClient.get(url.HOLDING + '/' + encodeURIComponent(holding));
export const addNewHolding = holding =>
	apiClient.post(url.ADD_HOLDING, holding);
export const updateHolding = holding =>
	apiClient.put(url.UPDATE_HOLDING + '/' + holding._id, holding);
export const deleteHolding = holding =>
	apiClient.delete(url.DELETE_HOLDING + '/' + holding._id);

// MaintenanceCompany
export const getMaintenanceCompanyList = () =>
	apiClient.get(url.GET_MAINTENANCE_COMPANY);
export const getMaintenanceCompany = holding =>
	apiClient.get(url.MAINTENANCE_COMPANY + '/' + encodeURIComponent(holding));
export const addNewMaintenanceCompany = holding =>
	apiClient.post(url.ADD_MAINTENANCE_COMPANY, holding);
export const updateMaintenanceCompany = holding =>
	apiClient.put(url.UPDATE_MAINTENANCE_COMPANY + '/' + holding._id, holding);
export const deleteMaintenanceCompany = holding =>
	apiClient.delete(url.DELETE_MAINTENANCE_COMPANY + '/' + holding._id);

// Managements
export const getManagementList = params => {
	return apiClient.get(`${url.GET_MANAGEMENTS}?${stringifyParams(params)}`);
};
export const getManagement = management =>
	apiClient.get(url.MANAGEMENT + '/' + encodeURIComponent(management));
export const addNewManagement = management =>
	apiClient.post(url.ADD_MANAGEMENT, management);
export const updateManagement = management =>
	apiClient.put(url.UPDATE_MANAGEMENT + '/' + management._id, management);
export const deleteManagement = management =>
	apiClient.delete(url.DELETE_MANAGEMENT + '/' + management._id);
export const getOrganizationalChart = () =>
	apiClient.get(url.ORGANIZATIONAL_CHART_MANAGEMENT);

// Management Teams
export const getManagementTeamList = params => {
	return apiClient.get(
		`${url.GET_MANAGEMENT_TEAMS}?${stringifyParams(params)}`
	);
};
export const getManagementTeam = management =>
	apiClient.get(url.MANAGEMENT_TEAM + '/' + encodeURIComponent(management));
export const addNewManagementTeam = management =>
	apiClient.post(url.ADD_MANAGEMENT_TEAM, management);
export const updateManagementTeam = management =>
	apiClient.put(url.UPDATE_MANAGEMENT_TEAM + '/' + management._id, management);
export const deleteManagementTeam = management =>
	apiClient.delete(url.DELETE_MANAGEMENT_TEAM + '/' + management._id);

// Management Position
export const getManagementPositionList = params => {
	return apiClient.get(
		`${url.GET_MANAGEMENT_POSITION}?${stringifyParams(params)}`
	);
};
export const getManagementPosition = management_position =>
	apiClient.get(
		url.MANAGEMENT_POSITION + '/' + encodeURIComponent(management_position)
	);
export const addNewManagementPosition = management_position =>
	apiClient.post(url.ADD_MANAGEMENT_POSITION, management_position);
export const updateManagementPosition = management_position =>
	apiClient.put(
		url.UPDATE_MANAGEMENT_POSITION + '/' + management_position._id,
		management_position
	);
export const deleteManagementPosition = management_position =>
	apiClient.delete(
		url.DELETE_MANAGEMENT_POSITION + '/' + management_position._id
	);

// // Warehouses
// export const getWarehouseList = () => { return apiClient.get(url.GET_WAREHOUSES); };
// export const getWarehouse = warehouse => apiClient.get(url.WAREHOUSE + '/' + encodeURIComponent(warehouse));
// export const addNewWarehouse = warehouse => apiClient.post(url.ADD_WAREHOUSE, warehouse);
// export const updateWarehouse = warehouse => apiClient.put(url.UPDATE_WAREHOUSE + '/' + warehouse._id, warehouse);
// export const deleteWarehouse = warehouse => apiClient.delete(url.DELETE_WAREHOUSE + '/' + warehouse._id);

// // Warehouses Item
// export const getWarehouseItemList = () => { return apiClient.get(url.GET_WAREHOUSE_ITEMS); };
// export const getWarehouseItem = warehouse_item => apiClient.get(url.WAREHOUSE_ITEM + '/' + encodeURIComponent(warehouse_item));
// export const addNewWarehouseItem = warehouse_item => apiClient.post(url.ADD_WAREHOUSE_ITEM, warehouse_item);
// export const updateWarehouseItem = warehouse_item => apiClient.put(url.UPDATE_WAREHOUSE_ITEM + '/' + warehouse_item._id, warehouse_item);
// export const deleteWarehouseItem = warehouse_item => apiClient.delete(url.DELETE_WAREHOUSE_ITEM + '/' + warehouse_item._id);
// export const checkWarehouseItemExists = name => apiClient.get(url.CHECK_WAREHOUSE_ITEM_EXISTS + '?name=' + name);

// // Warehouses Category
// export const getWarehouseCategoryList = () => { return apiClient.get(url.GET_WAREHOUSE_CATEGORIES); };
// export const getWarehouseCategory = warehouse_category => apiClient.get(url.WAREHOUSE_CATEGORY + '/' + encodeURIComponent(warehouse_category));
// export const addNewWarehouseCategory = warehouse_category => apiClient.post(url.ADD_WAREHOUSE_CATEGORY, warehouse_category);
// export const updateWarehouseCategory = warehouse_category => apiClient.put(url.UPDATE_WAREHOUSE_CATEGORY + '/' + warehouse_category._id, warehouse_category);
// export const deleteWarehouseCategory = warehouse_category => apiClient.delete(url.DELETE_WAREHOUSE_CATEGORY + '/' + warehouse_category._id);
// export const checkWarehouseCategoryExists = name => apiClient.get(url.CHECK_WAREHOUSE_CATEGORY_EXISTS + '?name=' + name);

// Productive Cycle
export const getProductiveCycleList = params =>
	apiClient.get(`${url.GET_PRODUCTIVE_CYCLE}?${stringifyParams(params)}`);
export const getProductiveCycleQuery = query =>
	apiClient.get(url.GET_PRODUCTIVE_CYCLE_QUERY + '?' + stringifyParams(query));
export const getProductiveCycle = productive_cycle =>
	apiClient.get(
		url.PRODUCTIVE_CYCLE + '/' + encodeURIComponent(productive_cycle)
	);
export const addNewProductiveCycle = productive_cycle =>
	apiClient.post(url.ADD_PRODUCTIVE_CYCLE, productive_cycle);
export const updateProductiveCycle = productive_cycle =>
	apiClient.put(
		url.UPDATE_PRODUCTIVE_CYCLE + '/' + productive_cycle._id,
		productive_cycle
	);
export const deleteProductiveCycle = productive_cycle =>
	apiClient.delete(url.DELETE_PRODUCTIVE_CYCLE + '/' + productive_cycle._id);

// Productive Cycle Status
export const getProductiveCycleStatusList = () =>
	apiClient.get(url.GET_PRODUCTIVE_CYCLE_STATUS);
export const getProductiveCycleStatus = productive_cycle_status =>
	apiClient.get(
		url.PRODUCTIVE_CYCLE_STATUS +
			'/' +
			encodeURIComponent(productive_cycle_status)
	);
export const addNewProductiveCycleStatus = productive_cycle_status =>
	apiClient.post(url.ADD_PRODUCTIVE_CYCLE_STATUS, productive_cycle_status);
export const updateProductiveCycleStatus = productive_cycle_status =>
	apiClient.put(
		url.UPDATE_PRODUCTIVE_CYCLE_STATUS + '/' + productive_cycle_status._id,
		productive_cycle_status
	);
export const deleteProductiveCycleStatus = productive_cycle_status =>
	apiClient.delete(
		url.DELETE_PRODUCTIVE_CYCLE_STATUS + '/' + productive_cycle_status._id
	);

// Productive Cycle Stage
export const getProductiveCycleStageList = () =>
	apiClient.get(url.GET_PRODUCTIVE_CYCLE_STAGE);
export const getProductiveCycleStage = productive_cycle_stage =>
	apiClient.get(
		url.PRODUCTIVE_CYCLE_STAGE +
			'/' +
			encodeURIComponent(productive_cycle_stage)
	);
export const addNewProductiveCycleStage = productive_cycle_stage =>
	apiClient.post(url.ADD_PRODUCTIVE_CYCLE_STAGE, productive_cycle_stage);
export const updateProductiveCycleStage = productive_cycle_stage =>
	apiClient.put(
		url.UPDATE_PRODUCTIVE_CYCLE_STAGE + '/' + productive_cycle_stage._id,
		productive_cycle_stage
	);
export const deleteProductiveCycleStage = productive_cycle_stage =>
	apiClient.delete(
		url.DELETE_PRODUCTIVE_CYCLE_STAGE + '/' + productive_cycle_stage._id
	);

// Productive Cycle Stage Template
export const getProductiveCycleStageTemplateList = params => {
	return apiClient.get(
		`${url.GET_PRODUCTIVE_CYCLE_STAGE_TEMPLATE}?${stringifyParams(params)}`
	);
};
export const getProductiveCycleStageTemplate =
	productive_cycle_stage_template =>
		apiClient.get(
			url.PRODUCTIVE_CYCLE_STAGE_TEMPLATE +
				'/' +
				encodeURIComponent(productive_cycle_stage_template)
		);
export const addNewProductiveCycleStageTemplate =
	productive_cycle_stage_template =>
		apiClient.post(
			url.ADD_PRODUCTIVE_CYCLE_STAGE_TEMPLATE,
			productive_cycle_stage_template
		);
export const updateProductiveCycleStageTemplate =
	productive_cycle_stage_template =>
		apiClient.put(
			url.UPDATE_PRODUCTIVE_CYCLE_STAGE_TEMPLATE +
				'/' +
				productive_cycle_stage_template._id,
			productive_cycle_stage_template
		);
export const deleteProductiveCycleStageTemplate =
	productive_cycle_stage_template =>
		apiClient.delete(
			url.DELETE_PRODUCTIVE_CYCLE_STAGE_TEMPLATE +
				'/' +
				productive_cycle_stage_template._id
		);
export const existsProductiveCycleStageTemplate = params => {
	return apiClient.post(
		`${url.EXISTS_PRODUCTIVE_CYCLE_STAGE_TEMPLATE}?${stringifyParams(params)}`
	);
};

// Species
export const getSpeciesList = () => apiClient.get(url.GET_SPECIES);
export const getSpecies = species =>
	apiClient.get(url.SPECIES + '/' + encodeURIComponent(species));
export const addNewSpecies = species =>
	apiClient.post(url.ADD_SPECIES, species);
export const updateSpecies = species =>
	apiClient.put(url.UPDATE_SPECIES + '/' + species._id, species);
export const deleteSpecies = species =>
	apiClient.delete(url.DELETE_SPECIES + '/' + species._id);

// FeedingBarges
export const getFeedingBargesList = params => {
	return apiClient.get(`${url.FEEDING_BARGES}?${stringifyParams(params)}`);
};
export const getFeedingBarges = feedingBarges =>
	apiClient.get(
		url.GET_FEEDING_BARGES + '/' + encodeURIComponent(feedingBarges)
	);
export const addNewFeedingBarges = feedingBarges =>
	apiClient.post(url.ADD_FEEDING_BARGES, feedingBarges);
export const updateFeedingBarges = feedingBarges =>
	apiClient.put(
		url.UPDATE_FEEDING_BARGES + '/' + feedingBarges._id,
		feedingBarges
	);
export const deleteFeedingBarges = feedingBarges =>
	apiClient.delete(url.DELETE_FEEDING_BARGES + '/' + feedingBarges._id);

// FeedingBarges Types
export const getFeedingBargesTypeList = () =>
	apiClient.get(url.GET_FEEDING_BARGES_TYPE);
export const getFeedingBargesType = feedingBargesType =>
	apiClient.get(
		url.FEEDING_BARGES_TYPE + '/' + encodeURIComponent(feedingBargesType)
	);
export const addNewFeedingBargesType = feedingBargesType =>
	apiClient.post(url.ADD_FEEDING_BARGES_TYPE, feedingBargesType);
export const updateFeedingBargesType = feedingBargesType =>
	apiClient.put(
		url.UPDATE_FEEDING_BARGES_TYPE + '/' + feedingBargesType._id,
		feedingBargesType
	);
export const deleteFeedingBargesType = feedingBargesType =>
	apiClient.delete(
		url.DELETE_FEEDING_BARGES_TYPE + '/' + feedingBargesType._id
	);

// CropType
export const getCropTypeList = () => apiClient.get(url.CROP_TYPE);
export const getCropType = cropType =>
	apiClient.get(url.GET_CROP_TYPE + '/' + encodeURIComponent(cropType));
export const addNewCropType = cropType =>
	apiClient.post(url.ADD_CROP_TYPE, cropType);
export const updateCropType = cropType =>
	apiClient.put(url.UPDATE_CROP_TYPE + '/' + cropType._id, cropType);
export const deleteCropType = cropType =>
	apiClient.delete(url.DELETE_CROP_TYPE + '/' + cropType._id);

// Fuel Types
export const getFuelTypeList = () => apiClient.get(url.GET_FUEL_TYPES);
export const getFuelType = fuelType =>
	apiClient.get(url.FUEL_TYPE + '/' + encodeURIComponent(fuelType));
export const addNewFuelType = fuelType =>
	apiClient.post(url.ADD_FUEL_TYPE, fuelType);
export const updateFuelType = fuelType =>
	apiClient.put(url.UPDATE_FUEL_TYPE + '/' + fuelType._id, fuelType);
export const deleteFuelType = fuelType =>
	apiClient.delete(url.DELETE_FUEL_TYPE + '/' + fuelType._id);

// Fuel Types Unit Measurement
export const getFuelTypeUnitMeasurementList = () =>
	apiClient.get(url.GET_FUEL_TYPE_UNIT_MEASUREMENTS);
export const getFuelTypeUnitMeasurement = fuelType =>
	apiClient.get(
		url.FUEL_TYPE_UNIT_MEASUREMENT + '/' + encodeURIComponent(fuelType)
	);
export const addNewFuelTypeUnitMeasurement = fuelType =>
	apiClient.post(url.ADD_FUEL_TYPE_UNIT_MEASUREMENT, fuelType);
export const updateFuelTypeUnitMeasurement = fuelType =>
	apiClient.put(
		url.UPDATE_FUEL_TYPE_UNIT_MEASUREMENT + '/' + fuelType._id,
		fuelType
	);
export const deleteFuelTypeUnitMeasurement = fuelType =>
	apiClient.delete(url.DELETE_FUEL_TYPE_UNIT_MEASUREMENT + '/' + fuelType._id);

// Power Generation Types
export const getPowerGenerationTypeList = () =>
	apiClient.get(url.GET_POWER_GENERATION_TYPES);
export const getPowerGenerationType = powerGenerationType =>
	apiClient.get(
		url.POWER_GENERATION_TYPE + '/' + encodeURIComponent(powerGenerationType)
	);
export const addNewPowerGenerationType = powerGenerationType =>
	apiClient.post(url.ADD_POWER_GENERATION_TYPE, powerGenerationType);
export const updatePowerGenerationType = powerGenerationType =>
	apiClient.put(
		url.UPDATE_POWER_GENERATION_TYPE + '/' + powerGenerationType._id,
		powerGenerationType
	);
export const deletePowerGenerationType = powerGenerationType =>
	apiClient.delete(
		url.DELETE_POWER_GENERATION_TYPE + '/' + powerGenerationType._id
	);

// Power Generation Status
export const getPowerGenerationStatusList = () =>
	apiClient.get(url.GET_POWER_GENERATION_STATUS);
export const getPowerGenerationStatus = powerGenerationStatus =>
	apiClient.get(
		url.POWER_GENERATION_STATUS +
			'/' +
			encodeURIComponent(powerGenerationStatus)
	);
export const addNewPowerGenerationStatus = powerGenerationStatus =>
	apiClient.post(url.ADD_POWER_GENERATION_STATUS, powerGenerationStatus);
export const updatePowerGenerationStatus = powerGenerationStatus =>
	apiClient.put(
		url.UPDATE_POWER_GENERATION_STATUS + '/' + powerGenerationStatus._id,
		powerGenerationStatus
	);
export const deletePowerGenerationStatus = powerGenerationStatus =>
	apiClient.delete(
		url.DELETE_POWER_GENERATION_STATUS + '/' + powerGenerationStatus._id
	);

// Power Generation Register Status
export const getPowerGenerationRegisterStatusList = () =>
	apiClient.get(url.GET_POWER_GENERATION_REGISTER_STATUS);
export const getPowerGenerationRegisterStatus = powerGenerationRegisterStatus =>
	apiClient.get(
		url.POWER_GENERATION_REGISTER_STATUS +
			'/' +
			encodeURIComponent(powerGenerationRegisterStatus)
	);
export const getPowerGenerationRegisterStatusCode = code =>
	apiClient.get(
		url.POWER_GENERATION_REGISTER_STATUS_CODE + '/' + encodeURIComponent(code)
	);
export const addNewPowerGenerationRegisterStatus =
	powerGenerationRegisterStatus =>
		apiClient.post(
			url.ADD_POWER_GENERATION_REGISTER_STATUS,
			powerGenerationRegisterStatus
		);
export const updatePowerGenerationRegisterStatus =
	powerGenerationRegisterStatus =>
		apiClient.put(
			url.UPDATE_POWER_GENERATION_REGISTER_STATUS +
				'/' +
				powerGenerationRegisterStatus._id,
			powerGenerationRegisterStatus
		);
export const deletePowerGenerationRegisterStatus =
	powerGenerationRegisterStatus =>
		apiClient.delete(
			url.DELETE_POWER_GENERATION_REGISTER_STATUS +
				'/' +
				powerGenerationRegisterStatus._id
		);

// Power Generation Source
export const getPowerGenerationSourceList = params => {
	return apiClient.get(
		`${url.GET_POWER_GENERATION_SOURCE}?${stringifyParams(params)}`
	);
};
export const getPowerGenerationSource = powerGenerationSource =>
	apiClient.get(
		url.POWER_GENERATION_SOURCE +
			'/' +
			encodeURIComponent(powerGenerationSource)
	);
export const addNewPowerGenerationSource = powerGenerationSource =>
	apiClient.post(url.ADD_POWER_GENERATION_SOURCE, powerGenerationSource);
export const updatePowerGenerationSource = powerGenerationSource =>
	apiClient.put(
		url.UPDATE_POWER_GENERATION_SOURCE + '/' + powerGenerationSource._id,
		powerGenerationSource
	);
export const deletePowerGenerationSource = powerGenerationSource =>
	apiClient.delete(
		url.DELETE_POWER_GENERATION_SOURCE + '/' + powerGenerationSource._id
	);

// Power Generation Hour Meter
export const getPowerGenerationHourMeterList = params => {
	return apiClient.get(
		`${url.GET_POWER_GENERATION_HOUR_METER}?${stringifyParams(params)}`
	);
};
export const getPowerGenerationHourMeterQuery = params => {
	return apiClient.get(
		`${url.GET_POWER_GENERATION_HOUR_METER_QUERY}?${stringifyParams(params)}`
	);
};
export const getPowerGenerationHourMeterSummaryQuery = params => {
	return apiClient.get(
		`${url.POWER_GENERATION_HOUR_METER_SUMMARY_QUERY}?${stringifyParams(params)}`
	);
};
export const getPowerGenerationDailyConsumptionQuery = params => {
	return apiClient.get(
		`${url.POWER_GENERATION_HOUR_METER_DAILY_CONSUMPTION_QUERY}?${stringifyParams(params)}`
	);
};
export const getPowerGenerationHourMeter = powerGenerationHourMeter =>
	apiClient.get(
		url.POWER_GENERATION_HOUR_METER +
			'/' +
			encodeURIComponent(powerGenerationHourMeter)
	);
export const addNewPowerGenerationHourMeter = powerGenerationHourMeter =>
	apiClient.post(
		url.ADD_POWER_GENERATION_HOUR_METER,
		powerGenerationHourMeter
	);
export const updatePowerGenerationHourMeter = powerGenerationHourMeter =>
	apiClient.put(
		url.UPDATE_POWER_GENERATION_HOUR_METER +
			'/' +
			powerGenerationHourMeter._id,
		powerGenerationHourMeter
	);
export const deletePowerGenerationHourMeter = powerGenerationHourMeter =>
	apiClient.delete(
		url.DELETE_POWER_GENERATION_HOUR_METER +
			'/' +
			powerGenerationHourMeter._id
	);

// Power Generation Maintenance
export const getPowerGenerationMaintenanceList = params => {
	return apiClient.get(
		`${url.GET_POWER_GENERATION_MAINTENANCE}?${stringifyParams(params)}`
	);
};
export const getPowerGenerationMaintenance = powerGenerationMaintenance =>
	apiClient.get(
		url.POWER_GENERATION_MAINTENANCE +
			'/' +
			encodeURIComponent(powerGenerationMaintenance)
	);
export const addNewPowerGenerationMaintenance = powerGenerationMaintenance =>
	apiClient.post(
		url.ADD_POWER_GENERATION_MAINTENANCE,
		powerGenerationMaintenance
	);
export const updatePowerGenerationMaintenance = powerGenerationMaintenance =>
	apiClient.put(
		url.UPDATE_POWER_GENERATION_MAINTENANCE +
			'/' +
			powerGenerationMaintenance._id,
		powerGenerationMaintenance
	);
export const deletePowerGenerationMaintenance = powerGenerationMaintenance =>
	apiClient.delete(
		url.DELETE_POWER_GENERATION_MAINTENANCE +
			'/' +
			powerGenerationMaintenance._id
	);

// Fuel Tank
export const getFuelTankList = params => {
	return apiClient.get(`${url.GET_FUEL_TANK}?${stringifyParams(params)}`);
};
export const getFuelTankListByEstablishment = params =>
	apiClient.get(
		url.FUEL_TANK_BY_ESTABLISHMENT + '/?' + stringifyParams(params)
	);
export const getFuelTank = fuelTank =>
	apiClient.get(url.FUEL_TANK + '/' + encodeURIComponent(fuelTank));
export const addNewFuelTank = fuelTank =>
	apiClient.post(url.ADD_FUEL_TANK, fuelTank);
export const updateFuelTank = fuelTank =>
	apiClient.put(url.UPDATE_FUEL_TANK + '/' + fuelTank._id, fuelTank);
export const deleteFuelTank = fuelTank =>
	apiClient.delete(url.DELETE_FUEL_TANK + '/' + fuelTank._id);

// Feeding Silo
export const getFeedingSiloList = params => {
	return apiClient.get(`${url.GET_FEEDING_SILO}?${stringifyParams(params)}`);
};
export const getFeedingSilo = feedingSilo =>
	apiClient.get(url.FEEDING_SILO + '/' + encodeURIComponent(feedingSilo));
export const addNewFeedingSilo = feedingSilo =>
	apiClient.post(url.ADD_FEEDING_SILO, feedingSilo);
export const updateFeedingSilo = feedingSilo =>
	apiClient.put(url.UPDATE_FEEDING_SILO + '/' + feedingSilo._id, feedingSilo);
export const deleteFeedingSilo = feedingSilo =>
	apiClient.delete(url.DELETE_FEEDING_SILO + '/' + feedingSilo._id);

// Fuel Supply
export const getFuelSupplyList = params => {
	return apiClient.get(`${url.GET_FUEL_SUPPLY}?${stringifyParams(params)}`);
};
export const getFuelSupplyListQuery = params => {
	return apiClient.get(
		`${url.GET_FUEL_SUPPLY_QUERY}?${stringifyParams(params)}`
	);
};
export const getFuelSupply = fuelSupply =>
	apiClient.get(url.FUEL_SUPPLY + '/' + encodeURIComponent(fuelSupply));
export const addNewFuelSupply = fuelSupply =>
	apiClient.post(url.ADD_FUEL_SUPPLY, fuelSupply);
export const updateFuelSupply = fuelSupply =>
	apiClient.put(url.UPDATE_FUEL_SUPPLY + '/' + fuelSupply._id, fuelSupply);
export const deleteFuelSupply = fuelSupply =>
	apiClient.delete(url.DELETE_FUEL_SUPPLY + '/' + fuelSupply._id);
// export const getFuelSupplySummary = () => apiClient.post(url.FUEL_SUPPLY_SUMMARY);
export const getFuelSupplySummary = params => {
	return apiClient.post(
		`${url.FUEL_SUPPLY_SUMMARY}?${stringifyParams(params)}`
	);
};
export const getFuelSupplySummaryQuery = params => {
	return apiClient.get(
		`${url.FUEL_SUPPLY_SUMMARY_QUERY}?${stringifyParams(params)}`
	);
};
export const getSupplyByCenterQuery = params => {
	return apiClient.get(
		`${url.FUEL_SUPPLY_BY_CENTER_QUERY}?${stringifyParams(params)}`
	);
};
export const getFuelSupplySummaryByEstablishment = (establishment_id, code) =>
	apiClient.post(
		url.FUEL_SUPPLY_SUMMARY_BY_ESTABLISHMENT +
			'/' +
			establishment_id +
			'/' +
			code
	);
export const getFuelSupplySummaryByMonth = () =>
	apiClient.post(url.FUEL_SUPPLY_SUMMARY_BY_MONTH);
export const getConsumptionByEstablishment = params => {
	return apiClient.get(
		`${url.FUEL_SUPPLY_CONSUMPTION_BY_ESTABLISHMENT}?${stringifyParams(
			params
		)}`
	);
};
export const getConsumptionTypeSummary = params => {
	return apiClient.get(
		`${url.FUEL_SUPPLY_CONSUMPTION_TYPE_SUMMARY}?${stringifyParams(params)}`
	);
};
export const getHourMeterSummary = params => {
	return apiClient.get(`${url.HOUR_METER_SUMMARY}?${stringifyParams(params)}`);
};
export const getEmissionsSummary = params => {
	return apiClient.get(`${url.EMISSIONS_SUMMARY}?${stringifyParams(params)}`);
};
export const getConsumptionsSummary = params => {
	return apiClient.get(
		`${url.CONSUMPTIONS_SUMMARY}?${stringifyParams(params)}`
	);
};

// Fuel Supply Type
export const getFuelSupplyTypeList = params => {
	return apiClient.get(
		`${url.GET_FUEL_SUPPLY_TYPE}?${stringifyParams(params)}`
	);
};
export const getFuelSupplyType = fuelSupplyType =>
	apiClient.get(
		url.FUEL_SUPPLY_TYPE + '/' + encodeURIComponent(fuelSupplyType)
	);
export const getFuelSupplyTypeCode = fuelSupplyType =>
	apiClient.get(
		url.FUEL_SUPPLY_TYPE_CODE + '/' + encodeURIComponent(fuelSupplyType)
	);
export const addNewFuelSupplyType = fuelSupplyType =>
	apiClient.post(url.ADD_FUEL_SUPPLY_TYPE, fuelSupplyType);
export const updateFuelSupplyType = fuelSupplyType =>
	apiClient.put(
		url.UPDATE_FUEL_SUPPLY_TYPE + '/' + fuelSupplyType._id,
		fuelSupplyType
	);
export const deleteFuelSupplyType = fuelSupplyType =>
	apiClient.delete(url.DELETE_FUEL_SUPPLY_TYPE + '/' + fuelSupplyType._id);

// Maintenance Type
export const getMaintenanceTypeList = params => {
	return apiClient.get(
		`${url.GET_MAINTENANCE_TYPE}?${stringifyParams(params)}`
	);
};
export const getMaintenanceType = maintenanceType =>
	apiClient.get(
		url.MAINTENANCE_TYPE + '/' + encodeURIComponent(maintenanceType)
	);
export const addNewMaintenanceType = maintenanceType =>
	apiClient.post(url.ADD_MAINTENANCE_TYPE, maintenanceType);
export const updateMaintenanceType = maintenanceType =>
	apiClient.put(
		url.UPDATE_MAINTENANCE_TYPE + '/' + maintenanceType._id,
		maintenanceType
	);
export const deleteMaintenanceType = maintenanceType =>
	apiClient.delete(url.DELETE_MAINTENANCE_TYPE + '/' + maintenanceType._id);

// Maintenance Status
export const getMaintenanceStatusList = params => {
	return apiClient.get(
		`${url.GET_MAINTENANCE_STATUS}?${stringifyParams(params)}`
	);
};
export const getMaintenanceStatus = maintenanceStatus =>
	apiClient.get(
		url.MAINTENANCE_STATUS + '/' + encodeURIComponent(maintenanceStatus)
	);
export const getMaintenanceStatusCode = code =>
	apiClient.get(
		url.GET_MAINTENANCE_STATUS_CODE + '/' + encodeURIComponent(code)
	);
export const addNewMaintenanceStatus = maintenanceStatus =>
	apiClient.post(url.ADD_MAINTENANCE_STATUS, maintenanceStatus);
export const updateMaintenanceStatus = maintenanceStatus =>
	apiClient.put(
		url.UPDATE_MAINTENANCE_STATUS + '/' + maintenanceStatus._id,
		maintenanceStatus
	);
export const deleteMaintenanceStatus = maintenanceStatus =>
	apiClient.delete(
		url.DELETE_MAINTENANCE_STATUS + '/' + maintenanceStatus._id
	);

// Person
export const getPersonList = params => {
	return apiClient.get(`${url.GET_PERSONS}?${stringifyParams(params)}`);
};
export const getPersonQuery = params => {
	return apiClient.get(`${url.GET_PERSONS_QUERY}?${stringifyParams(params)}`);
};
export const getPerson = person =>
	apiClient.get(url.PERSON + '/' + encodeURIComponent(person));
export const addNewPerson = person => apiClient.post(url.ADD_PERSON, person);
export const updatePerson = person =>
	apiClient.put(url.UPDATE_PERSON + '/' + person._id, person);
export const deletePerson = person =>
	apiClient.delete(url.DELETE_PERSON + '/' + person._id);
// export const importPerson = person => apiClient.post(url.IMPORT_PERSON, person);

export const importPerson = async data => {
	try {
		const response = await apiClient.post(url.IMPORT_PERSON, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response;
	} catch (error) {
		console.error(
			'Error al importar persona:',
			error.response?.data || error
		);
		throw error;
	}
};

// Sector
export const getSectorList = params => {
	return apiClient.get(`${url.GET_SECTORS}?${stringifyParams(params)}`);
};
export const getSector = person =>
	apiClient.get(url.SECTOR + '/' + encodeURIComponent(person));
export const addNewSector = person => apiClient.post(url.ADD_SECTOR, person);
export const updateSector = person =>
	apiClient.put(url.UPDATE_SECTOR + '/' + person._id, person);
export const deleteSector = person =>
	apiClient.delete(url.DELETE_SECTOR + '/' + person._id);

// PropertyTypes
export const getPropertyTypeList = params => {
	return apiClient.get(`${url.GET_PROPERTY_TYPES}?${stringifyParams(params)}`);
};
export const getPropertyType = propertyType =>
	apiClient.get(url.ESTABLISHMENT + '/' + encodeURIComponent(propertyType));
export const addNewPropertyType = propertyType =>
	apiClient.post(url.ADD_PROPERTY_TYPE, propertyType);
export const updatePropertyType = propertyType =>
	apiClient.put(
		url.UPDATE_PROPERTY_TYPE + '/' + propertyType._id,
		propertyType
	);
export const deletePropertyType = propertyType =>
	apiClient.delete(url.DELETE_PROPERTY_TYPE + '/' + propertyType._id);

// EstablishmentStatus
export const getEstablishmentStatusList = params => {
	return apiClient.get(
		`${url.ESTABLISHMENT_STATUS_LIST}?${stringifyParams(params)}`
	);
};
export const getEstablishmentStatus = establishmentStatus =>
	apiClient.get(
		url.GET_ESTABLISHMENT_STATUS +
			'/' +
			encodeURIComponent(establishmentStatus)
	);
export const addNewEstablishmentStatus = establishmentStatus =>
	apiClient.post(url.ADD_ESTABLISHMENT_STATUS, establishmentStatus);
export const updateEstablishmentStatus = establishmentStatus =>
	apiClient.put(
		url.UPDATE_ESTABLISHMENT_STATUS + '/' + establishmentStatus._id,
		establishmentStatus
	);
export const deleteEstablishmentStatus = establishmentStatus =>
	apiClient.delete(
		url.DELETE_ESTABLISHMENT_STATUS + '/' + establishmentStatus._id
	);

// Consumption Source
export const getConsumptionSourceList = params => {
	return apiClient.get(
		`${url.GET_CONSUMPTION_SOURCE}?${stringifyParams(params)}`
	);
};
export const getConsumptionSource = consumptionSource =>
	apiClient.get(
		url.CONSUMPTION_SOURCE + '/' + encodeURIComponent(consumptionSource)
	);
export const addNewConsumptionSource = consumptionSource =>
	apiClient.post(url.ADD_CONSUMPTION_SOURCE, consumptionSource);
export const updateConsumptionSource = consumptionSource =>
	apiClient.put(
		url.UPDATE_CONSUMPTION_SOURCE + '/' + consumptionSource._id,
		consumptionSource
	);
export const deleteConsumptionSource = consumptionSource =>
	apiClient.delete(
		url.DELETE_CONSUMPTION_SOURCE + '/' + consumptionSource._id
	);

// Consumption Source Type
export const getConsumptionSourceTypeList = params => {
	return apiClient.get(
		`${url.GET_CONSUMPTION_SOURCE_TYPE}?${stringifyParams(params)}`
	);
};
export const getConsumptionSourceType = consumptionSourceType =>
	apiClient.get(
		url.CONSUMPTION_SOURCE_TYPE +
			'/' +
			encodeURIComponent(consumptionSourceType)
	);
export const addNewConsumptionSourceType = consumptionSourceType =>
	apiClient.post(url.ADD_CONSUMPTION_SOURCE_TYPE, consumptionSourceType);
export const updateConsumptionSourceType = consumptionSourceType =>
	apiClient.put(
		url.UPDATE_CONSUMPTION_SOURCE_TYPE + '/' + consumptionSourceType._id,
		consumptionSourceType
	);
export const deleteConsumptionSourceType = consumptionSourceType =>
	apiClient.delete(
		url.DELETE_CONSUMPTION_SOURCE_TYPE + '/' + consumptionSourceType._id
	);

// Consumption Type
export const getConsumptionTypeList = params => {
	return apiClient.get(
		`${url.GET_CONSUMPTION_TYPE}?${stringifyParams(params)}`
	);
};
export const getConsumptionType = consumptionType =>
	apiClient.get(
		url.CONSUMPTION_TYPE + '/' + encodeURIComponent(consumptionType)
	);
export const addNewConsumptionType = consumptionType =>
	apiClient.post(url.ADD_CONSUMPTION_TYPE, consumptionType);
export const updateConsumptionType = consumptionType =>
	apiClient.put(
		url.UPDATE_CONSUMPTION_TYPE + '/' + consumptionType._id,
		consumptionType
	);
export const deleteConsumptionType = consumptionType =>
	apiClient.delete(url.DELETE_CONSUMPTION_TYPE + '/' + consumptionType._id);
